import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StoreService {
  storeData: any = {};
  url: string = `${environment.apiUrl}v1/Store`;

  constructor(private http: HttpClient) {}

  getStores() {
    return this.http.get(`${this.url}/List`);
  }

  addNewStore(storeInfo: any) {
    return this.http.post(`${this.url}/RegisterStore`, storeInfo);
  }

  getStoreById(storeId: number) {
    return this.http.get(`${this.url}/${storeId}`);
  }

  deleteStore(storeId: number) {
    return this.http.delete(`${this.url}/DeleteStore/${storeId}`);
  }

  getStoreAdmins(storeId: number) {
    return this.http.get(`${this.url}/${storeId}/Admins`);
  }

  activateStore(storeId: number) {
    return this.http.put(`${this.url}/Activate/${storeId}`, {});
  }
}
